var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 21.775C11.4583 21.775 10.9979 21.5854 10.6187 21.2063C10.2395 20.8271 10.05 20.3667 10.05 19.825H13.95C13.95 20.3667 13.7604 20.8271 13.3812 21.2063C13.002 21.5854 12.5416 21.775 12 21.775ZM8.09995 18.775V16.9H15.9V18.775H8.09995ZM8.32495 15.85C7.20828 15.1833 6.32495 14.2958 5.67495 13.1875C5.02495 12.0792 4.69995 10.8677 4.69995 9.55315C4.69995 7.5245 5.40938 5.80014 6.82825 4.38008C8.24713 2.96003 9.97005 2.25 11.997 2.25C14.024 2.25 15.7479 2.96003 17.1687 4.38008C18.5895 5.80014 19.3 7.5245 19.3 9.55315C19.3 10.8677 18.975 12.0792 18.325 13.1875C17.675 14.2958 16.7916 15.1833 15.675 15.85H8.32495ZM8.8954 13.975H15.1C15.8416 13.4583 16.4145 12.814 16.8187 12.0421C17.2229 11.2702 17.425 10.4408 17.425 9.55395C17.425 8.04298 16.8989 6.76042 15.8468 5.70625C14.7946 4.65208 13.5124 4.125 12 4.125C10.4875 4.125 9.20526 4.65152 8.15313 5.70455C7.10101 6.7576 6.57495 8.041 6.57495 9.55475C6.57495 10.4433 6.77703 11.2729 7.1812 12.0437C7.58537 12.8146 8.15677 13.4583 8.8954 13.975Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTip);
export default __webpack_public_path__ + "static/media/icon-tip.c05bc8f98d634ae45231da72c6b011ba.svg";
export { ForwardRef as ReactComponent };